import {ConnectSuccessLayout} from "./ConnectSuccessLayout.tsx";

export function AccountingConnectSuccessPage(props: { redirectTo: string }) {
    return <ConnectSuccessLayout
        title={"Boekhoudpakket succesvol gekoppeld!"}
        description={"Het is ons gelukt om de koppeling met je boekhoudpakket succesvol tot stand te brengen. Je kunt nu sluiten en teruggaan naar het dashboard."}
        buttonLabel={"Naar dashboard"}
        redirectTo={props.redirectTo}
    />;
}
